import clsx from 'clsx'

import styles from './SidebarNav.module.css'

const SidebarNav = ({
	children,
	className,
	...props
}: React.HTMLAttributes<HTMLDivElement>): JSX.Element => {
	return (
		<nav className={clsx(styles.sidebarNav, className)} {...props}>
			<ul>{children}</ul>
		</nav>
	)
}

export default SidebarNav
